import { render } from "./Gestor.vue?vue&type=template&id=99a5e8b6"
import script from "./Gestor.vue?vue&type=script&lang=js"
export * from "./Gestor.vue?vue&type=script&lang=js"

import "./Gestor.vue?vue&type=style&index=0&id=99a5e8b6&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\2. Fabrica 2022\\Proyecto_Andres_Fabrica\\proyecto_llaves\\version_principal\\frontend_proyecto_llaves\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__